"use client";

import Link from "next/link";
import { motion, Variants } from "framer-motion";
import Image from "next/image";

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

export default function AppDetailSection() {
  return (
    <>
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-10 md:py-20">
        {/* 타이틀 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex flex-row items-center justify-center mb-14 md:mb-20">
            <span
              className="text-lg text-white mr-4 md:mr-10 w-9 h-9 md:w-11 md:h-11 rounded-lg md:rounded-2xl bg-[#DA6363] items-center flex justify-center"
              style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
            >
              3
            </span>
            <p
              className="text-xl md:text-3xl text-black-almostBlack tracking-tight"
              style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
            >
              장소 디테일
            </p>
          </div>
        </motion.div>
        <motion.div
          className="flex flex-col justify-center items-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          <motion.p
            className="mt-5 md:mt-12 xl:mt-16  text-2xl md:text-3xl xl:text-4xl text-black-almostBlack leading-8 md:leading-12 tracking-tight"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
            variants={{
              hidden: { opacity: 0, y: 10 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5 }}
          >
            함께 수집한 공간 정보를 한눈에!
          </motion.p>
          <motion.p
            className="text-base md:text-xl xl:text-2xl sm:text-xl md:leading-8 xl:leading-9 leading-6  mt-10 text-black-100 text-center tracking-tight"
            variants={{
              hidden: { opacity: 0, y: 10 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5 }}
            style={{ fontFamily: '"pre-Medium", sans-serif' }}
          >
            주출입구(계단, 턱, 경사로)부터 엘리베이터, 주차장, 화장실,
            <br />
            장애인 객실, 입간판경사로 유무까지
            <br />
            필요한 편의시설 정보를 쉽고 빠르게 확인할 수 있어요.
          </motion.p>
        </motion.div>
        <motion.div
          className="relative w-full mx-auto my-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* 데스크톱 이미지: md 이상에서만 보여줌 */}
          <div className="relative w-full aspect-[1268/935] max-h-[940px] hidden md:block">
            <Image
              src="/assets/images/page/service/wemap/detailWeb.svg"
              alt="wemap screen desktop"
              fill
              className="object-contain object-right-top"
            />
          </div>

          {/* 모바일 이미지: md 이하에서만 보여줌 */}
          <div className="relative w-full aspect-[337/1778] max-h-[1778px] md:hidden">
            <Image
              src="/assets/images/page/service/wemap/detailMobile.svg"
              alt="wemap screen mobile"
              fill
              className="object-contain object-top"
            />
          </div>
        </motion.div>
      </div>
      {/* 라운드 */}
      <div className="relative h-20 md:h-32 ">
        <div className="absolute inset-0 bg-[#26293A] z-0" />
        <div className="absolute inset-x-0 top-0  h-20 md:h32 bg-white rounded-b-[40px] md:rounded-b-[120px] z-10 pt-20 md:pt-32" />
      </div>
    </>
  );
}
